import { createFileRoute } from "@tanstack/react-router";
import { CloudAccountDetail } from "../../../features/infrastructure/cloud-detail";

export const Route = createFileRoute("/_authed/$org/infrastructure/cloudaccounts/$name")({ component: Page });

function Page() {
  const { org, name } = Route.useParams();
  return <CloudAccountDetail org={org} name={name} />;
}
